<template>
    <div class="rlms-flex rlms-flex-col rlms-gap-desk30-mob-20">
        <!-- Header with buttons -->
        <div class="rlms-flex rlms-items-center rlms-justify-between rlms-flex-wrap rlms-gap-10">
            <div class="rlms-fs-lg rlms-fw-600">Administrators</div>
        </div>


        <div class="rlms-table">
            <div class="rlms-table-inner">
                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Join Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- Owner Row -->
                        <tr v-if="ownerData">
                            <td>
                                <label class="rlms-flex rlms-items-center rlms-gap-10 rlms-w-fc rlms-us-none">
                                    <div class="rlms-flex rlms-items-center rlms-gap-10 rlms-w-mc">
                                        <img :src="profileIcon">
                                        <p class="rlms-fw-500">
                                            {{ ownerData.firstname }} {{ ownerData.lastname }} <small>(Owner)</small>
                                        </p>
                                    </div>
                                </label>
                            </td>
                            <td>{{ ownerData.email }}</td>
                            <td>
                                <p class="rlms-text-extra-3">{{ formatDate(organization.created_at) }}</p>
                            </td>
                        </tr>

                        <!-- Administrator Rows -->
                        <template v-if="administrators.length > 0">
                            <tr v-for="admin in administrators" :key="admin.id">
                                <td>
                                    <label class="rlms-flex rlms-items-center rlms-gap-10 rlms-w-fc rlms-us-none">
                                        <input type="checkbox" :value="admin.id" v-model="selectedUsers"
                                            class="rlms-checkbox">
                                        <div class="rlms-flex rlms-items-center rlms-gap-10 rlms-w-mc">
                                            <img :src="profileIcon">
                                            <p class="rlms-fw-500">{{ admin.details.firstname }} {{
                                                admin.details.lastname
                                                }}</p>
                                        </div>
                                    </label>
                                </td>
                                <td>{{ admin.details.email }}</td>
                                <td>
                                    <p class="rlms-text-extra-3">{{ formatDate(admin.created_at) }}</p>
                                </td>
                            </tr>
                        </template>

                        <!-- No administrators message -->
                        <tr v-if="!administrators.length && !ownerData">
                            <td colspan="5">
                                <div class="rlms-flex rlms-flex-col rlms-gap-30 rlms-text-center rlms-p-3">
                                    <img :src="noDataImg" class="rlms-mx-auto"
                                        style="width: clamp(150px, -1533rem + 3200vw, 150px);">
                                    <p class="rlms-text-center">No record found.</p>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <paginate v-model="page" :page-count="totalPages" :margin-pages="2" :prev-text="'<'" :next-text="'>'"
            :container-class="'pagination'" :page-class="'page-item'" :active-class="'active-page'"
            v-if="totalPages > 1" />
    </div>
</template>
<script setup>
import { useRoute } from 'vue-router'
import { onMounted, ref, watch } from 'vue'
import axios from "@/services/axios";
import { formatDate } from '@/utils/format-helpers';
import { debounce } from '@/utils/debounce';
import paginate from 'vuejs-paginate-next';
import { handleError } from '@/utils/handleError';
import { useLoaderStore } from '@/stores/loader';
import profileIcon from '@/assets/images/profile.svg'
import noDataImg from '@/assets/images/no-data-img.png'

const route = useRoute();
const loader = useLoaderStore();

const page = ref(1);
const totalPages = ref(1);
const totalItems = ref(0);

const organizationId = Number(route.params.organization ?? 0);
const organization = ref(null);
const ownerData = ref(null);
const administrators = ref([]);

const selectedUsers = ref([]);
const showModal = ref(false);

const filter = ref({
    search: ''
});

onMounted(async () => {
    await init();
});

const init = async () => {
    selectedUsers.value = [];
    filter.value.search = '';
    page.value = 1;

    showModal.value = false;
    await fetchData();
}

const fetchData = async (search = filter.value.search) => {
    try {
        loader.show();

        const { data } = await axios.get(`/admin/administrators`, {
            params: {
                search,
                page: page.value,
                per_page: 10,
                organization_id: organizationId
            }
        });

        organization.value = data?.data?.organization ?? null;
        ownerData.value = organization.value?.user ?? null;
        administrators.value = data.data.administrators.data;

        // Optional: store pagination meta if needed
        totalPages.value = data.data.administrators.last_page;
        totalItems.value = data.data.administrators.total;

        filter.value.search = search;
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
};


watch(page, () => {
    fetchData();
});

// eslint-disable-next-line
const handleSearch = debounce(function () {
    page.value = 1;
    fetchData(filter.value.search);
}, 400);
</script>